import { Stack, Box } from '@mui/material';
import { SweepFullLogo } from '../../common/SweepFullLogo';
import type { ReactNode } from 'react';
import { Button, colors, IconButton } from '@sweep-io/sweep-design';
import useLogout from '../../../auth/useLogout';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons/ArrowLeft';
//These tags exist to send LinkedIn conversion event (part of marketing funnel)
//They should be placed right after signup, on the first screen of the onboarding
const CONVERSION_TAGS = (
  <>
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=4566474&conversionId=17240762&fmt=gif"
    />
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=4566474&conversionId=17240754&fmt=gif"
    />
  </>
);

const OnboardingLayout = ({
  children,
  withLogout,
  goBack,
}: {
  children: ReactNode;
  withLogout?: boolean;
  goBack?: () => void;
}) => {
  const { logout } = useLogout();

  return (
    <Stack height="100%">
      {CONVERSION_TAGS}
      <Box
        sx={{
          width: '100%',
          height: '76px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 32px',
          borderBottom: `1px solid ${colors.grey[120]}`,
          flex: '0 0 76px',
        }}
      >
        <SweepFullLogo width={98} height={25} />
        {withLogout && (
          <Button size="medium" variant="flat-blue" onClick={logout}>
            Log out
          </Button>
        )}
      </Box>
      {goBack && (
        <Stack p={2}>
          <IconButton variant="flat" size="small" onClick={goBack}>
            <ArrowLeft />
          </IconButton>
        </Stack>
      )}
      <Box
        flex={1}
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ overflowY: 'auto' }}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default OnboardingLayout;
